import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { getPrettyDate } from 'utils/util/util';
import { AvatarBasicPerson } from 'views/Widgets/People/UnlinkedAvatar';

const FeedbackDeclinedOverlay: FC<{
  ap: AvatarBasicPerson;
}> = ({ ap }) => {
  const { locale } = useIntl();
  // @ts-expect-error
  if (ap?.declined_date)
    return (
      <div>
        <FormattedMessage
          id="app.views.administration.content_administration.feedback_recognition.requested.table.column.declined_at.value.deleted"
          defaultMessage="Request declined on {date}"
          values={{
            // @ts-expect-error
            date: getPrettyDate({ dateString: ap.declined_date, locale }),
          }}
        />
        {/* @ts-expect-error */}
        {!!ap.declined_comments && (
          <div>
            <FormattedMessage
              id="app.views.administration.content_administration.feedback_recognition.requested.table.column.declined_at.value.comments"
              defaultMessage="Comments: {comments}"
              // @ts-expect-error
              values={{ comments: ap.declined_comments }}
            />
          </div>
        )}
      </div>
    );
  return null;
};

export default React.memo(FeedbackDeclinedOverlay);
